module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "BRK4_Page_break"
  }, [_c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "COS1"
  }, [_vm._v("He did it quite quickly, before she opened her mouth to start again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("It had started in the kitchen. He’d thought they could have sex first so he had started that way, looking into her face and touching as she talked. But then she kept on talking, "), _c('i', [_vm._v("You didn’t think")]), _vm._v(", her voice hardening, "), _c('i', [_vm._v("you never thought this was—")]), _vm._v(" slapping his hand away, then her voice rising until the sound of it set up a vibration in his head that had its own momentum, that he knew wouldn’t stop until he put an end to it, and it was simply there as the solution. There was really very little in that moment to be said against it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("He had smiled down at her then. He had never seen what other people saw: good-looking, ugly. In the pub he listened to what the others said about women, looking at the images on the big screen high in the corner, a woman under a shower with her head back and water running "), _c('span', {
    attrs: {
      "aria-label": "4",
      "id": "pg_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("down her body, they talked about the shape of her arse. He had a different range. He saw things they couldn’t see.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("Then as he walked her backward through the door and—registering her expression changing, her eyes going flat in the made-up face because she thought she knew why he wanted her in there, thought she could handle him—it occurred to him that the bedroom was a better place to do it anyway, because the window looked out over the fields and it was less likely that the neighbors would hear something. Although not impossible: he knew they heard things, it just hadn’t been of interest to him until now.")]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("They had gotten as far as the bed, so he let the body fall there, a shine on her legs from the window. As she went down in all the bedclothes there was a wet sound from her throat and for a flashing red second he thought maybe he hadn’t done it properly so he waited. But he considered that it must have been just air forced back out of the lungs somehow, perhaps as the body folded on itself, because she was certainly dead.")]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("Her bedside table was dusty, and the bin in the corner was overflowing. Dirty. Lazy. On the bed now her face was half hidden in the duvet, and he leaned over her, he knelt astride her breasts, looking down, and carefully he moved the fabric out of the way so he could see. He stepped back off the bed. Her legs were open and between them the dark. They could have gone on, another month or two at least. She’d been stupid, that was all. He began to consider that: How stupid?")]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("Coming around the bed to the window, he looked for a second: the meadow was uncut and shaggy as far as the "), _c('span', {
    attrs: {
      "aria-label": "5",
      "id": "pg_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("tidal river. It had been hot a month now, a heat wave across Europe, it said on the news, five thousand dead, although most of them old people. The grass was turning to straw.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX1"
  }, [_vm._v("He drew the curtains, then he turned to go into the kitchen. He was going to need a knife.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 78
// module chunks = 0